'use client'

import { SearchIcon, Typography } from '@hermes/web-components'
import { useState } from 'react'
import { SuggestionButton } from './Result.styles'

export const SuggestionButtonSearch = ({ label, onClick }: { label: string; onClick: () => void }) => {
  const [hover, setHover] = useState(false)
  return (
    <SuggestionButton onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} onClick={onClick}>
      <Typography fontWeight={500} component="span">
        {label}
      </Typography>
      {hover && <SearchIcon width="21px" />}
    </SuggestionButton>
  )
}
